import { __assign } from "tslib";
import React from 'react';
import LineChart from '../line/line-chart.component';
export var AreaChart = function (props) {
    return React.createElement(LineChart, __assign({}, props, { areaMode: true }));
};
export default AreaChart;
